<template>
  <header class="app-header">
    <div class="header-actions">
      <div class="balance-pill" aria-hidden="true">
        <img class="asset-ico" :src="sliceUrl('asset.png')" alt="" />
      </div>
      <el-avatar
        class="avatar"
        size="medium"
        src="https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png"
      />
    </div>
  </header>
</template>

<script>
export default {
  name: 'AppHeader',
  methods: {
    sliceUrl(name) {
      return `${process.env.BASE_URL}slices/${name}`
    }
  }
}
</script>

<style lang="scss" scoped>
.app-header {
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 0 28px;
  flex-shrink: 0;
  background: #171b32;
  border-bottom: none;
}

.header-actions {
  display: flex;
  align-items: center;
  gap: 16px;
}

.balance-pill {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 8px 10px;
  border-radius: 999px;
  background: rgba(22, 26, 44, 0.95);
  border: 1px solid rgba(55, 65, 90, 0.5);
}

.asset-ico {
  width: 26px;
  height: 26px;
  object-fit: contain;
  flex-shrink: 0;
  display: block;
}

.avatar {
  border: 2px solid rgba(124, 58, 237, 0.45);
}
</style>
